import { Injectable } from '@angular/core';
import { ServicesService } from 'app/resources/services/services.service';
import { HttpService } from 'app/resources/services/http.service';
import { Item } from 'app/resources/classes/item';

@Injectable()
export class ValePresenteCestaService {
  public hasError: boolean;
  public itens: Array<any> = [];
  public itensInvalidos: Array<any> = undefined;
  public item: Item = new Item();

  constructor(public servicesService: ServicesService, public http: HttpService) { }

  public markAsInvalid(valePresente, mensagemErro) {
    for (let i = 0; i < this.itens.length; i++) {
      const _item = this.itens[i];

      if (_item.valePresente.id === valePresente.id && _item.valePresente.uuid === valePresente.uuid) {
        _item.isInvalid = true;
        _item.invalidMessage = mensagemErro;

        if (this.itensInvalidos === undefined) {
          this.itensInvalidos = [];
        }
        this.itensInvalidos.push(_item);
      }
    }
  };

  public resetInvalidItens() {
    this.itensInvalidos = undefined;
  };

  public add(valePresente, quantidade, indiceConversaoMoeda) {
    this.resetInvalidItens();

    if (valePresente && quantidade && quantidade > 0) {
      this.item = new Item(valePresente, valePresente.valor,
        this.servicesService.moedaToPontos(valePresente.valor, indiceConversaoMoeda),
        parseInt(quantidade, 10));
      this.itens.push(this.item);
      return true;
    }
    return false;
  }

  public validate() {
    this.hasError = false;
    this.resetInvalidItens();
    this.itens.forEach(item => {
      this.http.pathRest().post('valepresente/pedidos/itens/validar/', item, true)
        .subscribe(
        sucesso => {
          if (sucesso.status === 202) {
            if (this.itensInvalidos === undefined) {
              this.itensInvalidos = [];
            }
          } else {
            this.markAsInvalid(item.valePresente, 'Erro não informado pelo servidor!');
          }
        }, erro => {
          if (erro.status === 409) {
            this.markAsInvalid(item.valePresente, erro._body);
            this.hasError = true;
          } else {
            this.markAsInvalid(item.valePresente, 'Erro não informado pelo servidor!');
          }
        });
    });
  }
  public remove(valePresente) {
    this.resetInvalidItens();
    const that = this;
    this.itens = this.itens.filter(item => {
      if (item.valePresente.id !== valePresente.id ||
        (item.valePresente.id === valePresente.id && item.valePresente.valor !== valePresente.valor)) {
        return item;
      }
    });
    return false;
  }

  public clean() {
    this.resetInvalidItens();
    this.itens = [];
  }

  public hasValePresente(valePresente) {
    const found = this.itens.filter(function (item) {
      if (item.valePresente.id === valePresente.id && item.valePresente.valor === valePresente.valor) {
        return item.valePresente;
      }
    });
    return found[0] && (!found[0].variavel || (found[0].variavel && found[0].valor === valePresente.valor));
  }

  public getItens() {
    return this.itens;
  }

  public isValid() {
    return this.itens.length > 0 && this.itensInvalidos !== undefined && this.itensInvalidos.length === 0;
  }

  public totalItens() {
    let total = 0;

    this.itens.forEach((item) => {
      total += item.quantidade;
    });
    return total;
  }

  public valorTotal() {
    let valor = 0.00;
    this.itens.forEach((item) => {
      valor += item.valorTotal();
    });
    return valor;
  }

  public pontosTotais() {
    let pontos = 0;
    this.itens.forEach((item) => {
      pontos += item.pontosTotais();
    });
    return pontos;
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/services/vale-presente-cesta-service.service.ts